export default "__VITE_ASSET__DusEYnAr__"